import { AlignRight } from './EditSensorData.styles';
import { Button } from '@innovyze/stylovyze';
import React from 'react';

export interface ConfirmModalFooterProps {
	closeConfirmModal: () => void;
}
export const ConfirmModalFooter = ({
	closeConfirmModal,
}: ConfirmModalFooterProps) => (
	<AlignRight>
		<Button
			dataCy="dataEditorConfirmModalButton"
			variant="contained"
			color="primary"
			onClick={() => {
				closeConfirmModal();
			}}>
			Confirm
		</Button>
	</AlignRight>
);
